import {EvBatteryPerformanceStatus} from '@di-shared/features/home/kr/ev-battery/monitor/const';

export function getIsLowBatteryChargeBannerVisible(soc: number) {
  return 20 <= soc && soc <= 25;
}

export function getIsMonthlyChargeRemindeBannerVisible(lastChargeDate: Date | null) {
  if (!(lastChargeDate instanceof Date)) {
    return false; // 유효한 Date가 아니면 false 반환
  }
  const today = new Date();
  const diffTime = today.getTime() - lastChargeDate.getTime();
  const diffDays = diffTime / (1000 * 60 * 60 * 24);
  return 20 <= diffDays && diffDays <= 30;
}

export function getEvBatteryPerformanceStatus(soh: number) {
  /**
   * @link https://jira.hmg-corp.io/browse/DRIVINGINS-968
   * soh가 0일 경우 에러 처리
   */
  if (soh <= 0) {
    return EvBatteryPerformanceStatus.ERROR;
  }
  if (80 <= soh) {
    return EvBatteryPerformanceStatus.GOOD;
  }
  return EvBatteryPerformanceStatus.NORMAL;
}
